import { VENDOR_COSTS } from './constants';
import partners from '../Data/PartnerTypesV1';

export const calculateCosts = (filteredLocations, selectedSiteTypes, selectedVendors) => {
  // First, deduplicate locations and exclude NA sizes
  const uniqueLocations = [...new Set(filteredLocations.map(loc => loc.abbreviation))]
    .map(abbr => filteredLocations.find(loc => loc.abbreviation === abbr))
    .filter(location => location.size !== 'NA'); // Exclude NA sites first

  const costs = {};

  selectedVendors.forEach((vendor) => {
    costs[vendor] = 0;
    // Then filter for selected types
    uniqueLocations
      .filter(location => selectedSiteTypes.includes(location.size))
      .forEach(location => {
        costs[vendor] += VENDOR_COSTS[vendor][location.size];
      });
  });

  return costs;
};

export const calculateSiteTypeCosts = (locations, siteType, selectedVendors) => {
  // Deduplicate locations and exclude NA sizes
  const uniqueLocations = [...new Set(locations.map(loc => loc.abbreviation))]
    .map(abbr => locations.find(loc => loc.abbreviation === abbr))
    .filter(loc => loc.size !== 'NA' && loc.size === siteType);

  const costs = {};

  selectedVendors.forEach((vendor) => {
    costs[vendor] = uniqueLocations.reduce((total, location) => {
      return total + VENDOR_COSTS[vendor][location.size];
    }, 0);
  });

  return costs;
};

export const calculatePartnerCosts = (filteredLocs, selectedPartners, partnerType, siteTypes) => {
  // Handle case where selectedPartners is undefined or null
  if (!selectedPartners) return 0;
  
  // Ensure selectedPartners is always an array
  const partnersArray = Array.isArray(selectedPartners) ? selectedPartners : [selectedPartners];
  
  // If no partners selected or empty array, return 0
  if (partnersArray.length === 0) return 0;

  // Filter out NA sites before counting
  const totalSelectedSites = filteredLocs.filter((loc) =>
    loc.size !== 'NA' && siteTypes.includes(loc.size)
  ).length;

  return partnersArray.reduce((total, partnerName) => {
    if (partners[partnerType] && partners[partnerType][partnerName]) {
      return total + partners[partnerType][partnerName].pricePerYear * totalSelectedSites;
    }
    return total;
  }, 0);
};

// Additional helper calculation functions
export const calculateTotalCosts = (costs) => {
  return Object.values(costs).reduce((a, b) => a + b, 0);
};

export const calculateAverageCost = (costs) => {
  const total = calculateTotalCosts(costs);
  const count = Object.keys(costs).length;
  return count > 0 ? total / count : 0;
};

export const calculateSiteCostByType = (location, vendor) => {
  if (location.size === 'NA' || !VENDOR_COSTS[vendor]) return 0;
  return VENDOR_COSTS[vendor][location.size];
};

export const calculateTotalPartnerCosts = (partnerCosts) => {
  return Object.values(partnerCosts).reduce((a, b) => a + b, 0);
};